import { render, staticRenderFns } from "./choiceAddTorrent.vue?vue&type=template&id=65412384&scoped=true&"
import script from "./choiceAddTorrent.vue?vue&type=script&lang=js&"
export * from "./choiceAddTorrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65412384",
  null
  
)

export default component.exports